import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type VerticalLayout from './vertical-layout.vue'

// 定义组件props
export const verticalLayoutProps = buildProps({
  topHeight: {
    type: definePropType<string | number>([String, Number]),
    default: '40px',
  },
  verticalSpace: {
    type: definePropType<string | number>([String, Number]),
    default: '8px',
  },
} as const)

// props
export type VerticalLayoutProps = ExtractPropTypes<typeof verticalLayoutProps>

// instance
export type VerticalLayoutInstance = InstanceType<typeof VerticalLayout>
